/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Type_Heating_CurveInputs */



/**
* | output |
* | --- |
* | "Heating curve" |
*
* @param {Entity_Type_Heating_CurveInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const entity_type_heating_curve = /** @type {((inputs?: Entity_Type_Heating_CurveInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Type_Heating_CurveInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Heating curve")
	return /** @type {LocalizedString} */ ("Courbe de chauffe")
});